import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import ByObserver from './byObserver';

var BySubject = /*#__PURE__*/function () {
  function BySubject() {
    _classCallCheck(this, BySubject);

    this.observerList = new Set();
  }

  _createClass(BySubject, [{
    key: "attachObserver",
    value: function attachObserver(observer) {
      if (observer instanceof ByObserver) {
        this.observerList.add(observer);
      }
    }
  }, {
    key: "notifyObservers",
    value: function notifyObservers(args) {
      this.observerList.forEach(function (val) {
        val.update(args);
      });
    }
  }]);

  return BySubject;
}();

export { BySubject as default };